import request from '../../utils/request';

export function getRoutePlanRiders(params) {
  const { id } = params;
  return request(`/route-plans/` + id + '/riders', {
    method: 'GET',
  });
}

export function addRiderToRoutePlan(params) {
  const { riderId, id } = params;
  return request(`/route-plans/${id}/riders/${riderId}`, {
    method: 'POST',
  });
}
